import { createContext } from 'react'

const ConnectionContext = createContext(1)
export default ConnectionContext